import { Box, CircularProgress } from "@mui/material";

function LoadingFallback() {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
      <CircularProgress />
    </Box>
  );
}

export default LoadingFallback;
